import $ from 'jquery';

export default class Unlink {
  constructor(element) {
    this.$element = $(element);
    this.unlink();
  }

  unlink() {
    return this.$element.children().unwrap();
  }
}
